import { Await } from "react-router-dom";
import { PodcastPageContext } from "@app/types/Page";
import CustomError from "@components/Error/CustomError";
import { CustomContext, useRouteContext } from "@sphtech/web2-core/ssr";

import PodcastPageContent from "./PodcastPageContent";

export default function PodcastsPage(): React.ReactElement {
  const { context }: CustomContext<PodcastPageContext> = useRouteContext();

  return (
    <Await resolve={context} errorElement={<CustomError />}>
      {({ kind, error, data }) => {
        return kind !== "section" || error ? (
          <h1>Error</h1>
        ) : (
          <PodcastPageContent {...{ data }} />
        );
      }}
    </Await>
  );
}
